import { newState, transitionState, stateFingerprint, canJugglerThrow, } from "./pattern/state";
function transitionFingerprint(cursors) {
    return cursors.join(":");
}
function beat(pattern, state, cursors) {
    const beatsPerJuggler = [];
    const cursors2 = cursors.slice();
    pattern.patterns.forEach((p, nr) => {
        if (!canJugglerThrow(state, nr)) {
            beatsPerJuggler.push(null);
        }
        else {
            let cursor = cursors[nr];
            const beat = p.beats[cursor++];
            if (cursor === p.beats.length) {
                cursor = 0;
            }
            cursors2[nr] = cursor;
            beatsPerJuggler.push(beat);
        }
    });
    const state2 = transitionState(state, beatsPerJuggler);
    return [state2, cursors2];
}
export function loopFinder(p) {
    const jugglerCount = p.patterns.length;
    let state = newState(jugglerCount);
    const states = [state];
    let cursors = p.patterns.map((p) => 0);
    let statePrint2idx = {};
    let stateTransKey2statePrint = {};
    while (states.length < 500) {
        const tfp = transitionFingerprint(cursors);
        const sfp = stateFingerprint(state);
        statePrint2idx[sfp] = states.length - 1;
        const key = `${sfp} x ${tfp}`;
        const targetSfp = stateTransKey2statePrint[key];
        if (typeof targetSfp !== "undefined") {
            const targetIdx = statePrint2idx[targetSfp];
            if (typeof targetIdx === "undefined") {
                throw new Error();
            }
            return states.slice(targetIdx);
        }
        const [state2, cursors2] = beat(p, state, cursors);
        stateTransKey2statePrint[key] = stateFingerprint(state2);
        states.push(state2);
        cursors = cursors2;
        state = state2;
    }
    throw new Error("no loop found");
}
